// Application
export const APP_NAME = process.env.REACT_APP_NAME || "MyApp";
export const API = process.env.REACT_APP_API || "";
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL || "";
export const HASH_SECRET = process.env.REACT_APP_HASH_SECRET || "";
export const PRODUCT_ID = process.env.REACT_APP_PRODUCT_ID || 21;

// Payments
export const PAYMENT_API = process.env.REACT_APP_PAYMENT_API || "";
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || "";

// Keycloak
export const KEYCLOAK_URL = process.env.REACT_APP_KEYCLOAK_URL || "";
export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM || "";
export const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT || "";
export const KEYCLOAK_SECRET = process.env.REACT_APP_SECRET || "";

// Auth
export const AUTH_LOCALSTORAGE_NAME = `${APP_NAME}-Auth`;
export const ROOT_API = API + "/vms-api";

// Ngrok API
// export const ROOT_API = "https://9fa771be1138.ngrok-free.app/vms-api";
